module.exports = __webpack_public_path__ + "img/pProject-banner2.3fe5f858.jpg";